module.exports = __webpack_public_path__ + "img/scan.bed7d1ef.png";